import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconAnthropic: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2689_6309)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6644 7.63336H27.9188L37.5 31.6667H32.2456L22.6644 7.63336ZM12.0798 7.63336H17.5733L27.1546 31.6667H21.7967L19.8381 26.6194H9.81646L7.85646 31.6652H2.5L12.0813 7.63628L12.0798 7.63336ZM18.1056 22.1569L14.8273 13.7102L11.549 22.1584H18.1042L18.1056 22.1569Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2689_6309">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconAnthropic.defaultProps = defaultIconProps;
